// Badge.jsx
import { Box } from "@mui/material";

import woodBadge from "../../assets/wood_badge.png";
import bronzeBadge from "../../assets/bronze_badge.png";
import silverBadge from "../../assets/silver_badge.png";
import goldBadge from "../../assets/gold_badge.png";
import uraniumBadge from "../../assets/uranium_badge.png";


const BADGE_IMAGES = {
  wood: woodBadge,
  bronze: bronzeBadge,
  silver: silverBadge,
  gold: goldBadge,
  uranium: uraniumBadge,
};

const Badge = ({ xp = 0, thresholds, size = 64 }) => {
  let badgeKey = "wood";

  if (thresholds) {
    const x = Number(xp) || 0;
    if (x >= thresholds.uranium_xp) badgeKey = "uranium";
    else if (x >= thresholds.gold_xp) badgeKey = "gold";
    else if (x >= thresholds.silver_xp) badgeKey = "silver";
    else if (x >= thresholds.bronze_xp) badgeKey = "bronze";
  }

  const src = BADGE_IMAGES[badgeKey];

  return (
    <Box sx={{ width: size, height: size }}>
      <Box
        component="img"
        src={src}
        alt={`badge-${badgeKey}`}
        sx={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </Box>
  );
};

export default Badge;
